import apiClient from "../api/apiClient";

const PENDING_CART_KEY = "mockee_pending_cart_items";

const normalizeItem = (item) => {
  const product_id = item?.product_id ?? item?.productId;
  if (product_id == null || product_id === "") return null;
  return {
    product_id,
    modelType: item.modelType || "listing",
  };
};

export const getPendingCartItems = () => {
  try {
    const raw = localStorage.getItem(PENDING_CART_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.map(normalizeItem).filter(Boolean);
  } catch {
    return [];
  }
};

export const hasPendingCartItems = () => getPendingCartItems().length > 0;

export const clearPendingCartItems = () => {
  try {
    localStorage.removeItem(PENDING_CART_KEY);
  } catch {
    // Ignore private-mode / blocked storage.
  }
};

export const queuePendingCartItem = (item) => {
  const next = normalizeItem(item);
  if (!next) return;
  const items = getPendingCartItems();
  const exists = items.some(
    (entry) =>
      String(entry.product_id) === String(next.product_id) &&
      entry.modelType === next.modelType
  );
  if (exists) return;
  try {
    localStorage.setItem(PENDING_CART_KEY, JSON.stringify([...items, next]));
  } catch {
    // Ignore private-mode / blocked storage.
  }
};

export const addCartItem = async (item) => {
  const next = normalizeItem(item);
  if (!next) return { ok: false };
  return apiClient.post("/cartitems/", next);
};

export const flushPendingCartItems = async () => {
  const items = getPendingCartItems();
  if (!items.length) return { added: 0 };
  let added = 0;
  for (const item of items) {
    const result = await addCartItem(item);
    if (result?.ok) added += 1;
  }
  clearPendingCartItems();
  return { added, attempted: items.length };
};
